import React from "react";
import { ModalContext } from "../../components/BrowserAlert/modalContext";
import {
  Box,
  Container,
  Typography,
  Divider,
  Button,
  ListItem,
  List,
  ListItemText,
} from "@common-ui/ui";
import { useHistory } from "react-router-dom";
export const AllSettings = () => {
  let { handleModal } = React.useContext(ModalContext);
  let router = useHistory();
  return (
    <>
      <Box
        component="main"
        sx={{
          alignItems: "center",
          display: "flex",
          flexGrow: 1,
          minHeight: "100%",
          backgroundColor: "#FFFFFF",
          ".MuiDataGrid-virtualScroller": {
            marginTop: "40px !important",
          },
          ".MuiDataGrid-columnHeaderTitle": {
            fontWeight: 700,
          },
          // bgcolor: "background.paper",
        }}
      >
        <Container maxWidth="md" component="main">
          <List sx={{ width: "100%", maxWidth: "100%" }}>
            <Typography color="textPrimary" variant="h3">
              Personal Settings
            </Typography>
            <ListItem
              alignItems="flex-start"
              justifyContent="space-between"
              sx={{ width: "100%", maxWidth: "100%", pr: 0, pl: 8 }}
              // onClick={() => alert("Coming Soon!")}
            >
              <ListItemText
                primary={
                  <Typography color="textPrimary" variant="h4">
                    Your Account
                  </Typography>
                }
                secondary={
                  <React.Fragment>
                    <Typography
                      sx={{ display: "inline" }}
                      component="span"
                      variant="body1"
                      color="text.secondary"
                    >
                      Contact info, password, and two-factor authentication
                    </Typography>
                    {/* {" — I'll be in your neighborhood doing errands this…"} */}
                  </React.Fragment>
                }
              />
              <div>
                <Button
                  color="primary"
                  disabled
                  // disabled={!(formik.isValid && formik.dirty)}
                  fullWidth
                  size="large"
                  type="submit"
                  variant="outlined"
                  onClick={() => {
                    // alert("Coming Soon!");
                    handleModal("Coming Soon!", "Alert");
                  }}
                >
                  Manage
                </Button>
              </div>
            </ListItem>
            <Typography color="textPrimary" variant="h3">
              Admin
            </Typography>
            <ListItem
              alignItems="flex-start"
              justifyContent="space-between"
              sx={{ width: "100%", maxWidth: "100%", pr: 0, pl: 8 }}
              // onClick={() => alert("Coming Soon!")}
            >
              <ListItemText
                primary={
                  <Typography color="textPrimary" variant="h4">
                    Subscriptions & Billing
                  </Typography>
                }
                secondary={
                  <React.Fragment>
                    <Typography
                      sx={{ display: "inline" }}
                      component="span"
                      variant="body1"
                      color="text.secondary"
                    >
                      Manage your organizations account
                    </Typography>
                    {/* {" — I'll be in your neighborhood doing errands this…"} */}
                  </React.Fragment>
                }
              />
              <div>
                <Button
                  color="primary"
                  disabled
                  // disabled={!(formik.isValid && formik.dirty)}
                  fullWidth
                  size="large"
                  type="submit"
                  variant="outlined"
                  onClick={() => {
                    // alert("Coming Soon!");
                    handleModal("Coming Soon!", "Alert");
                  }}
                >
                  Manage
                </Button>
              </div>
            </ListItem>
            <Divider component="li" sx={{ ml: 8, my: 2 }} />
            <ListItem
              alignItems="flex-start"
              justifyContent="space-between"
              sx={{ width: "100%", maxWidth: "100%", pr: 0, pl: 8 }}
              // onClick={() => alert("Coming Soon!")}
            >
              <ListItemText
                primary={
                  <Typography color="textPrimary" variant="h4">
                    Organizations
                  </Typography>
                }
                secondary={
                  <React.Fragment>
                    <Typography
                      sx={{ display: "inline" }}
                      component="span"
                      variant="body1"
                      color="text.secondary"
                    >
                      Create, edit, and manage organizations
                    </Typography>
                    {/* {" — I'll be in your neighborhood doing errands this…"} */}
                  </React.Fragment>
                }
              />
              <div>
                <Button
                  color="primary"
                  // disabled={!(formik.isValid && formik.dirty)}
                  fullWidth
                  size="large"
                  type="submit"
                  variant="outlined"
                  onClick={() => {
                    router.push("/orgs/tree-view/overview");
                  }}
                >
                  Manage
                </Button>
              </div>
            </ListItem>
            <Divider component="li" sx={{ ml: 8, my: 2 }} />
            <ListItem
              alignItems="flex-start"
              justifyContent="space-between"
              sx={{ width: "100%", maxWidth: "100%", pr: 0, pl: 8 }}
              // onClick={() => alert("Coming Soon!")}
            >
              <ListItemText
                primary={
                  <Typography color="textPrimary" variant="h4">
                    Customers and Vendors
                  </Typography>
                }
                secondary={
                  <React.Fragment>
                    <Typography
                      sx={{ display: "inline" }}
                      component="span"
                      variant="body1"
                      color="text.secondary"
                    >
                      Create, edit, and manage customers and vendors
                    </Typography>
                    {/* {" — I'll be in your neighborhood doing errands this…"} */}
                  </React.Fragment>
                }
              />
              <div>
                <Button
                  color="primary"
                  // disabled
                  // disabled={!(formik.isValid && formik.dirty)}
                  fullWidth
                  size="large"
                  type="submit"
                  variant="outlined"
                  onClick={() => {
                    // CHANGE TO '/org/:id/customer'
                    router.push("/customers");
                  }}
                >
                  Manage
                </Button>
              </div>
            </ListItem>
            {/* Maintenance Plans */}
            <Divider component="li" sx={{ ml: 8, my: 2 }} />
            <ListItem
              alignItems="flex-start"
              justifyContent="space-between"
              sx={{ width: "100%", maxWidth: "100%", pr: 0, pl: 8 }}
              // onClick={() => alert("Coming Soon!")}
            >
              <ListItemText
                primary={
                  <Typography color="textPrimary" variant="h4">
                    Maintenance Plans
                  </Typography>
                }
                secondary={
                  <React.Fragment>
                    <Typography
                      sx={{ display: "inline" }}
                      component="span"
                      variant="body1"
                      color="text.secondary"
                    >
                      Configure managed assets with repeatable planning
                    </Typography>
                    {/* {" — I'll be in your neighborhood doing errands this…"} */}
                  </React.Fragment>
                }
              />
              <div>
                <Button
                  color="primary"
                  // disabled
                  // disabled={!(formik.isValid && formik.dirty)}
                  fullWidth
                  size="large"
                  type="submit"
                  variant="outlined"
                  onClick={() => {
                    // CHANGE TO '/org/:id/customer'
                    router.push("/maintenance-plans");
                  }}
                >
                  Manage
                </Button>
              </div>
            </ListItem>
            {/* Services */}
            <Divider component="li" sx={{ ml: 8, my: 2 }} />
            <ListItem
              alignItems="flex-start"
              justifyContent="space-between"
              sx={{ width: "100%", maxWidth: "100%", pr: 0, pl: 8 }}
              // onClick={() => alert("Coming Soon!")}
            >
              <ListItemText
                primary={
                  <Typography color="textPrimary" variant="h4">
                    Services
                  </Typography>
                }
                secondary={
                  <React.Fragment>
                    <Typography
                      sx={{ display: "inline" }}
                      component="span"
                      variant="body1"
                      color="text.secondary"
                    >
                      Configure and manage services
                    </Typography>
                    {/* {" — I'll be in your neighborhood doing errands this…"} */}
                  </React.Fragment>
                }
              />
              <div>
                <Button
                  color="primary"
                  // disabled
                  // disabled={!(formik.isValid && formik.dirty)}
                  fullWidth
                  size="large"
                  type="submit"
                  variant="outlined"
                  onClick={() => {
                    // CHANGE TO '/org/:id/customer'
                    router.push("/services");
                  }}
                >
                  Manage
                </Button>
              </div>
            </ListItem>
            <Typography color="textPrimary" variant="h3">
              Apps
            </Typography>
            <ListItem
              alignItems="flex-start"
              justifyContent="space-between"
              sx={{ width: "100%", maxWidth: "100%", pr: 0, pl: 8 }}
              // onClick={() => alert("Coming Soon!")}
            >
              <ListItemText
                primary={
                  <Typography color="textPrimary" variant="h4">
                    Your Organizations Applications
                  </Typography>
                }
                secondary={
                  <React.Fragment>
                    <Typography
                      sx={{ display: "inline" }}
                      component="span"
                      variant="body1"
                      color="text.secondary"
                    >
                      View, update, and download
                    </Typography>
                    {/* {" — I'll be in your neighborhood doing errands this…"} */}
                  </React.Fragment>
                }
              />
              <div>
                <Button
                  color="primary"
                  disabled
                  // disabled={!(formik.isValid && formik.dirty)}
                  fullWidth
                  size="large"
                  type="submit"
                  variant="outlined"
                  onClick={() => {
                    // alert("Coming Soon!");
                    handleModal("Coming Soon!", "Alert");
                  }}
                >
                  Manage
                </Button>
              </div>
            </ListItem>
          </List>
        </Container>
      </Box>
    </>
  );
};
